import { HttpClient, HttpResponse } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Document, DocumentsResponse, Enum, FilterDocument, UpdateDocumentTagsAssigned, UploadFile } from '@interfaces'
import { BehaviorSubject, Observable } from 'rxjs'

@Injectable({
	providedIn: 'root'
})
export class DocumentsService {
	private http = inject(HttpClient)
	url = '/documents/documents'

	// Observable para guardar los datos seleccionados en el filtro
	private _filterDocumentSubjet = new BehaviorSubject<FilterDocument>({})
	filterDocument$ = this._filterDocumentSubjet.asObservable()

	// Observable para conocer los documentos seleccionados
	private _selectedDocumentsSubject = new BehaviorSubject<Document[]>([])
	selectedDocuments$ = this._selectedDocumentsSubject.asObservable()

	// Elimina una etiqueta de un documento
	deleteAssignedTags(idDocument: number, idTag: number): Observable<void> {
		return this.http.delete<void>(`${this.url}/${idDocument}/tag/${idTag}`)
	}

	// Llamada al endpoint para eliminar un docuemnto
	deleteDocument(id: number): Observable<void> {
		return this.http.delete<void>(`${this.url}/${id}`)
	}

	// Recoge la lista de documentos
	getDocuments(data: FilterDocument): Observable<DocumentsResponse> {
		return this.http.post<DocumentsResponse>(`${this.url}/search`, data)
	}

	// Devuelve un documento por su id
	getDocumentId(id: number): Observable<HttpResponse<Blob>> {
		return this.http.get(`${this.url}/${id}`, {
			observe: 'response',
			responseType: 'blob'
		})
	}

	// Obtiene el listado de tipos de documentos
	getDocumentTypes(): Observable<Enum[]> {
		return this.http.get<Enum[]>(`${this.url}/types`)
	}

	// Setea en el observable los documentos seleccionados en los checkbox
	setDocumentSelected(documents: Document[]) {
		this._selectedDocumentsSubject.next(documents)
	}

	// Setea los valores seleccionados para filtrar
	setFilterDocument(filterValues: FilterDocument) {
		this._filterDocumentSubjet.next(filterValues)
	}

	// Actualiza las etiquetas de un documento
	updateAssignedTags(data: UpdateDocumentTagsAssigned): Observable<void> {
		return this.http.post<void>(`${this.url}/${data.id}/tag`, data)
	}

	// Método para subir archivos
	uploadFiles(data: UploadFile): Observable<void> {
		return this.http.post<void>(`${this.url}/upload`, data)
	}
}
